// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5cx1k","left":"styles_left__1Uoby"};